import React from "react";
import Table, { dateColumn, defaultCol, getTextLabels } from "components/Form/Table";
import { IntlGetText } from "util/IntlMessages";

const linkCol = (name, textId, data, onPatientClick) => ({
  name,
  label: IntlGetText(textId),
  options: {
    filter: true,
    sort: true,
    customBodyRender: (value, tableMeta) => {
      const row = data[tableMeta.rowIndex];
      if (!row || !onPatientClick) return value || "";
      return (
        <span
          role="button"
          tabIndex={0}
          style={{ cursor: "pointer", color: "#3f51b5", textDecoration: "underline" }}
          onClick={() => onPatientClick(row)}
          onKeyPress={(e) => {
            if (e.key === "Enter") onPatientClick(row);
          }}
        >
          {value}
        </span>
      );
    },
  },
});

const FollowUpTable = ({
  data,
  count,
  page,
  rowsPerPage,
  showOds,
  showAlternateCode,
  onTableChange,
  onPatientClick,
}) => {
  const columns = [
    linkCol("code", "core.code", data, onPatientClick),
    ...(showAlternateCode ? [defaultCol("alternateCode", "core.alternateCodeAbbr")] : []),
    linkCol("firstName", "core.name", data, onPatientClick),
    linkCol("lastName", "core.lastName", data, onPatientClick),
    ...(showOds ? [defaultCol("ods", "core.ods")] : []),
    defaultCol("eps", "core.insurance"),
    defaultCol("olCompra", "patientFollowUp.olCompra"),
    defaultCol("olEntrega", "patientFollowUp.olEntrega"),
    defaultCol("institution", "patientFollowUp.institution"),
    defaultCol("ips", "patientFollowUp.ips"),
    defaultCol("doctor", "core.doctor"),
    defaultCol("specialty", "core.specialty"),
    dateColumn("expeditionDate", "patientFollowUp.expeditionDate"),
    defaultCol("city", "core.city"),
    defaultCol("numberDeliveries", "patientFollowUp.deliveries"),
    defaultCol("medicineAmount", "patientFollowUp.medicineAmount"),
    defaultCol("pharmaceuticalQuantity", "patientFollowUp.pharmaceuticalQuantity"),
    defaultCol("inTreatment", "patientFollowUp.inTreatment"),
    defaultCol("hasDelivery", "patientFollowUp.hasDelivery"),
    defaultCol("amountPackFactor", "patientFollowUp.amountPackFactor"),
    defaultCol("amount", "patientFollowUp.amount"),
    defaultCol("medicine", "core.product"),
    defaultCol("amountReceivedPackFactor", "patientFollowUp.amountReceivedPackFactor"),
    defaultCol("amountReceived", "patientFollowUp.amountReceived"),
    dateColumn("deliveryDate", "patientFollowUp.deliveryDate"),
    defaultCol("deliveryNumber", "patientFollowUp.deliveryNumber"),
    defaultCol("barrier", "patientFollowUp.barrier"),
    dateColumn("pendingFormatDate", "patientFollowUp.pendingFormatDate"),
    defaultCol("deliveryPoint", "patientFollowUp.deliveryPoint"),
    defaultCol("validPsp", "patientFollowUp.validPsp"),
    dateColumn("lastImpactEndDate", "patientFollowUp.lastImpactDate"),
    {
      name: "lastImpactComment",
      label: IntlGetText("patientFollowUp.lastImpactComment"),
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ({
          style: { minWidth: 400, width: 400 },
        }),
        setCellProps: () => ({
          style: {
            minWidth: 400,
            width: 400,
            whiteSpace: "normal",
            wordBreak: "break-word",
          },
        }),
      },
    },
    defaultCol("stateParent", "patientFollowUp.stateParent"),
    {
      name: "state",
      label: IntlGetText("patientFollowUp.state"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const row = data[tableMeta.rowIndex];
          if (!row) return value || "";
          const color = row.stateColor || "teal";
          return (
            <div className={"badge text-uppercase text-white bg-" + color}>
              {value}
            </div>
          );
        },
      },
    },
  ];

  const options = {
    filter: false,
    download: false,
    print: false,
    viewColumns: true,
    selectableRows: "none",
    serverSide: true,
    count,
    page,
    rowsPerPage,
    rowsPerPageOptions: [10, 25, 50],
    textLabels: getTextLabels(),
    onTableChange,
  };

  return (
    <Table
      title={IntlGetText("patientFollowUp.detail")}
      className="border-dialog-card"
      data={data}
      columns={columns}
      options={options}
    />
  );
};

export default FollowUpTable;
